(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire0d69"];
var parcelRegister = parcelRequire.register;
parcelRegister("e0QTP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a33a1980c81c8d2f$export$2e2bcd8739ae039; });
var $a33a1980c81c8d2f$var$filterSlider = function() {
    var filterableSliders = document.querySelectorAll(".js-slider-filter[data-id]");
    if (filterableSliders) Array.from(filterableSliders).forEach(function(el) {
        $(el).on("change", function(e) {
            var selectedLocation = e.target.value;
            var slider = $(el).find(".slick-slider");
            slider.slick("slickUnfilter");
            if (selectedLocation) {
                var selector = '[data-locations*="' + selectedLocation + '"]';
                slider.slick("slickFilter", selector);
            }
        });
    });
};
var $a33a1980c81c8d2f$export$2e2bcd8739ae039 = $a33a1980c81c8d2f$var$filterSlider;

});

})();
//# sourceMappingURL=filter-slider.53fbcadc.js.map
